// extracted by mini-css-extract-plugin
export default {"api":"api___gNxg3lv","subheader":"subheader___gNxg3lv","items":"items___gNxg3lv","item":"item___gNxg3lv","descr":"descr___gNxg3lv"};